import { Suggestion, SearchResult } from './suggestion.model';
import { WidgetUtil } from '../../../services/widgets.util';

export async function search(query: string, locale: string, domain: string): Promise<SearchResult> {
    const [unfilteredSuggestions, autocomplete] = await Promise.all([fetchSuggestions(locale, domain), fetchAutocomplete(query, locale, domain)]);

    const suggestions = unfilteredSuggestions.filter(suggestion => filter(suggestion, autocomplete));
    const available = suggestions.length > 0 || autocomplete.length > 0;

    const result = {
        available,
        autocomplete,
        suggestions
    };

    return result;
}

function filter(suggestion: Suggestion, autocomplete: string[]) {
    return suggestion
        .matches
        .some(s =>
            autocomplete
                .some(ac => ac.includes(s) || s.includes(ac))
        );
}

let suggestions: Promise<Suggestion[]>;
async function fetchSuggestions(locale: string, domain: string) {
    if (!suggestions) {
        const url = `${WidgetUtil.rootUrl()}/search/suggestions?l=${locale}&d=${domain}&a=100`;
        suggestions = fetch(url).then(res => res.json());
    }
    return Promise.resolve(suggestions);
}

async function fetchAutocomplete(query: string, locale: string, domain: string): Promise<string[]> {
    const url = `${WidgetUtil.rootUrl()}/search?l=${locale}&d=${domain}&q=${query}`;
    return await fetch(url)
        .then(res => res.text())
        .then(text => text.length ? JSON.parse(text) : []);
}
